import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, DialogContentText, CircularProgress } from '@mui/material'
import { LoadingButton } from '@mui/lab'
import PageService from '../../services/PageService'

const DeleteTestRunConfirmationModal = ({
  testRun,
  deleteOpen,
  setDeleteOpen
}) => {
  const [loading, setLoading] = useState(false)

  const navigate = useNavigate()

  const handleCloseDeleteDialog = () => {
    setDeleteOpen(false)
  }

  const handleDeleteTestRun = async () => {
    setLoading(true)
    try {
      await PageService.deleteTestRunById(testRun.id)
      setDeleteOpen(false)
      navigate(`/test-case/${testRun.testCaseId}`)
    } catch (error) {
      console.log(error.message)
      setLoading(false)
    }
  }

  return (
    <Dialog
      open={deleteOpen}
      onClose={handleCloseDeleteDialog}
    >
      <Box className="deleteTestRunModal">
        <DialogTitle className="deleteTestRunModalTitle">
          Confirm Delete Test Run
        </DialogTitle>
        <DialogContent className="deleteTestRunModalContent">
          <DialogContentText className="deleteTestRunModalContentText">
            Are you sure you want to delete this test run? This will permanently remove it from the system, and it cannot be restored.
          </DialogContentText>
        </DialogContent>
        <DialogActions className="deleteTestRunModalActions">
          <Button className="deleteTestRunModalButton" onClick={handleCloseDeleteDialog} color="secondary" variant="outlined">
            Cancel
          </Button>
          {loading ? (
            <LoadingButton
              loading
              className="deleteTestRunModalButton"
              variant="contained"
              loadingIndicator={<CircularProgress color="white" size={16} />}
            />
          ) : (
            <Button className="deleteTestRunModalButton" onClick={handleDeleteTestRun} color="error" variant="contained" autoFocus>
              Delete
            </Button>
          )}
        </DialogActions>
      </Box>
    </Dialog>
  )
}

export default DeleteTestRunConfirmationModal